module.exports = __webpack_public_path__ + "static/enlightenment-now-d1344cfcbd991116a94621f4cc42e22b.jpg";